<div style="padding:20px;">
  <div style="display: flex; justify-content: space-between;">
    <h2 class="cpo-dialog-title">Contact Updated</h2>
    <close-x (click)="close_click()"></close-x>
  </div>
  <div style="padding: 20px; align-items: center; justify-content: center; display: flex; flex-direction: column; gap: 10px;">
    <span style="font-family: Booton; color: var(--green-800); font-size: 16px; font-weight: 300;">Please contact the Swipesum Support Team at <span style="font-weight: 600; text-decoration: underline;">1-844-356-9905</span> to notify them of a change to your contacts.</span>
    <div style="display: flex; justify-content: center; gap: 10px; margin-top: 40px; padding-right: 30px;">
      <button class="btn-secondary" style="width: 200px;" (click)="close_click()">Close</button>
      <button class="btn-primary" style="width: 200px;" (click)="close_click()">Got it!</button>
    </div>
  </div>
</div>